import Button from '@cobliteam/colib-ui/Button';
import { useTranslation } from '@cobliteam/i18n';
import { Dialog, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import useContractRenewalVisibility from './useContractRenewalVisibility';

const DialogContractRenewal = () => {
  const { t } = useTranslation('contract-renewal');
  const { shouldShow, onClose } = useContractRenewalVisibility();

  if (!shouldShow) return null;

  return (
    <Dialog open>
      <Dialog.Content size='md'>
        <Dialog.Header>
          <Dialog.Title>{t('dialog.title')}</Dialog.Title>
          <Dialog.Description className='sr-only'>{t('dialog.description')}</Dialog.Description>
        </Dialog.Header>
        <Dialog.Body>
          <Typography variant='text-md'>{t('dialog.description')}</Typography>
        </Dialog.Body>
        <Dialog.Footer className='flex items-center justify-between gap-2'>
          <Button variant='ghost' onClick={onClose}>
            {t('dialog.close_for_now')}
          </Button>
          <div className='flex gap-2'>
            <Button variant='outline' render={<div className='flex items-center gap-2' />}>
              <Icon name='phone' />
              <a href='tel:+551148102200'>{t('dialog.phone_call')}</a>
            </Button>
            <Button render={<div className='flex items-center gap-2' />}>
              <Icon name='cb-whatsapp' />
              <a href='https://wa.me/551148102200' target='_blank' rel='noopener noreferrer'>
                {t('dialog.whatsapp_contact')}
              </a>
            </Button>
          </div>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default DialogContractRenewal;
